import { useQuery, useMutation, useQueryClient } from "react-query";
import { getAllNotificationByUser, clearAllNotificationByUser } from "../api-services/notification";

const notificationsKey = "user-notifications";

const useGetUserNotifications = (params) => {
	const queryResponse = useQuery({
		queryKey: [notificationsKey, params],
		queryFn: () => getAllNotificationByUser(params),
		refetchOnMount: true,
		refetchOnWindowFocus: false,
	});

	return {
		refetch: queryResponse.refetch,
		isError: queryResponse.isError,
		isSuccess: queryResponse.isSuccess,
		isLoading: queryResponse.isFetching,
		data:
			queryResponse.data?.filter( 
				(notification) => notification.status === 0
			) || [],
	};
};

const useClearNotifications = (mutationOptions = {}) => {
	const queryClient = useQueryClient();
	
	const mutation = useMutation({
		mutationFn: (payload) => clearAllNotificationByUser(payload),
		onSuccess: (data) => {
			// Invalidate notifications query to refetch
			queryClient.invalidateQueries([notificationsKey]);
			
			if (mutationOptions.onSuccess) {
				mutationOptions.onSuccess(data);
			}
		},
		onError: (error) => {
			if (mutationOptions.onError) {
				mutationOptions.onError(error);
			}
		},
	});

	return {
		clearNotifications: mutation.mutate, // Fixed: was "editClientProduct"
		isLoading: mutation.isPending,
		...mutation,
	};
};

export { useGetUserNotifications, useClearNotifications };